// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_hk","advertCardFooter__row":"c-a_hl","advertCardFooter__name":"c-a_hm","advertCardFooter__price":"c-a_hn","advertCardFooter__age":"c-a_ho"};